// Coerce free-form user input into a valid http(s) URL string.
// Returns null if the input can't be reasonably interpreted as a URL.
//
// - Trims whitespace.
// - Prepends `https://` when no protocol is supplied so users can type
//   "mysite.com/offer" and still pass validation.
// - Rejects non-http(s) protocols (mailto:, javascript:, etc.) since
//   those break trackable-link redirects.
export function coerceUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const u = new URL(candidate);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    return u.toString();
  } catch {
    return null;
  }
}
